// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all-cases-view table thead tr th:first-child .cell {\n  padding-left: 1em !important;\n}\n.all-cases-view table tbody tr td:first-child .cell a {\n  padding-left: 1em;\n  color: #1349a5 !important;\n}\n.all-cases-view .content {\n  margin-top: 20px;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
